// SaveChangesMessage.jsx
import { Button } from "antd";
import PropTypes from "prop-types";
import saveIcon from "../../../app/assets/images/Save.png";

const SaveChangesMessage = ({ onCancel, onSaveSuccess, isLoading }) => {
  const handleSave = () => {
    onCancel();
    onSaveSuccess();
  };

  return (
    <div className="flex flex-col align-middle items-center pt-16 pb-10">
      <img src={saveIcon} alt="Your Logo" className="h-24 w-auto" />
      <div className="text-center">
        <h2 className="font-semibold m-0 p-0 text-2xl">Save Changes?</h2>
        <p className="p-0 m-0">Recent changes will be saved</p>
      </div>
      <div className="flex flex-grow justify-end gap-6 mt-16">
        <Button
          size="large"
          className="w-40 !border-orange-500 !text-orange-500 !hover:text-orange-700 !hover:border-orange-700 font-semibold rounded-lg"
          onClick={onCancel}
        >
          CANCEL
        </Button>

        <Button
          type="primary"
          size="large"
          loading={isLoading}
          className="w-40 border-none font-semibold rounded-lg hover:bg-[#d5621e]"
          style={{
            backgroundColor: "#F45F0C",
            letterSpacing: "1px",
          }}
          onClick={handleSave}
        >
          SAVE
        </Button>
      </div>
    </div>
  );
};

export default SaveChangesMessage;
SaveChangesMessage.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSaveSuccess: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
